/**
 * date-fnsを使用する日付処理
 */
import _Vue from 'vue'

import { format } from 'date-fns'

export default {
  install(Vue: typeof _Vue): void {
    /**
     * 日付型を日付文字列に変換する
     * @param date Date
     * @returns { date: 'YYYY/MM/DD' time: 'HH:mm' }
     */
    const formatDateTime = function (date: Date): { date: string; time: string } {
      return { date: format(date, 'yyyy/MM/dd'), time: format(date, 'HH:mm') }
    }
    /**
     * 日付型をタイムスタンプ文字列に変換する
     * @param date Date
     * @returns 'YYYYMMDDHHmmss'
     */
    const formatTimestamp = function (date: Date): string {
      return format(date, 'yyyyMMddHHmmss')
    }
    Vue.prototype.$localDateFns = {
      formatDateTime,
      formatTimestamp,
    }
  },
}

/**
 * インターフェース定義
 */
declare module 'vue/types/vue' {
  interface Vue {
    $localDateFns: {
      formatDateTime: (date: Date) => { date: string; time: string }
      formatTimestamp: (date: Date) => string
    }
  }
}
